import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MODULAR.MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MODULAR.MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bx bx-home-circle',
        link: '/',

    },
    {
        id: 3,
        label: 'MODULAR.MENUITEMS.USERS.TEXT',
        icon: 'bx bx-user',
        link: '/users',
    },
    
    {
        id: 4,
        label: 'MODULAR.MENUITEMS.MACHINES.TEXT',
        icon: 'dripicons-user',
        link: '/machines',
    },
    {
        id: 5,
        label: 'MODULAR.MENUITEMS.TRANSACTION_REPORT.TEXT',
        icon: 'bx bx-file',
        link: '/transaction-report',
    },
    {
        id: 6,
        label: 'MODULAR.MENUITEMS.DAILY_COLLECTION_REPORT.TEXT',
        icon: 'bx bx-money',
        link: '/daily-collections',
    },
    // {
    //     id: 4,
    //     label: 'Merchants',
    //     icon: 'dripicons-user-group',
    //     link: '/merchants',
    // },
    // {
    //     id: 5,
    //     label: 'Transactions',
    //     icon: 'bx bx-list-ol',
    //     link: '/transaction',
    // },
    // {
    //     id: 2,
    //     label: 'DB Users',
    //     icon: 'mdi mdi-database-lock-outline',
    //     link: '/db-users',
    // },
    // {
    //     id: 2,
    //     label: 'API Generation',
    //     icon: 'bx bx-code-alt',
    //     link: '/api',
    // },
    // {
    //     id: 9,
    //     label: 'System Settings',
    //     icon: 'bx bx-cog',
    //     link: '/settings',

    //     // subItems: [
    //     //     {
    //     //         id: 13,
    //     //         label: 'Settings',
    //     //         link: '/point-settings',
    //     //         parentId: 9
    //     //     },
    //     //     {
    //     //         id: 13,
    //     //         label: 'Transactions',
    //     //         link: '/point-transactions',
    //     //         parentId: 9
    //     //     },
    //     // ]
    // },
 
];

